import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { CollapseChip } from "./CollapseChip.js";
import { ellipsisStyle } from "./text/Ellipsis.js";
export const CollapseTitle = ({ title, icon, count, variant = "h4", }) => {
    return (_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", minWidth: 0, children: [icon && (_jsx(Box, { display: "flex", flexShrink: 0, flexGrow: 0, children: icon })), _jsx(Typography, { variant: variant, color: "primary", textAlign: "left", sx: {
                    minWidth: 0,
                    flexShrink: 1,
                    flexGrow: 1,
                    // same as tabs
                    fontWeight: 500,
                    fontSize: "0.875rem",
                    lineHeight: 1.25,
                    letterSpacing: "0.02857em",
                    textTransform: "uppercase",
                    ...ellipsisStyle,
                }, children: title }), count !== undefined && (_jsx(Box, { display: "flex", alignItems: "center", ml: 0.5, component: "span", height: "1em", flexShrink: 0, flexGrow: 0, children: _jsx(CollapseChip, { label: count, sx: { ml: 0.5 } }) }))] }));
};
//# sourceMappingURL=CollapseTitle.js.map